import gql from "graphql-tag";

export default gql`
  mutation CreateCustomer($customerId: ID, $customerInput: CustomerInputInput) {
    createCustomer(customerId: $customerId, customerInput: $customerInput) {
      id
      description
    }
  }
`;
